<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="create_text" [ttModel]="edit.create_text" ttReadonly></tt-input>
        <tt-input ttLabel="stockplace_name" [ttModel]="edit.stockplace_name" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="edit.prod_id" ttReadonly [ttButtons]="productIdButtons"></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="edit.prod_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="quantity" [(ttModel)]="edit.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-button-save ttText="create" (ttClick)="createChanges()" [ttLoading]="creating"></tt-button-save>
    </tt-card>
</tt-page>
